import { render, staticRenderFns } from "./ChatMessagesCard.vue?vue&type=template&id=5dc8b96a&scoped=true&"
import script from "./ChatMessagesCard.vue?vue&type=script&lang=js&"
export * from "./ChatMessagesCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessagesCard.vue?vue&type=style&index=0&id=5dc8b96a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc8b96a",
  null
  
)

export default component.exports